import React from "react";
import Axios from "axios";
import Moment from "react-moment";
import logo from "../../ISQ-Logo.jpg";
import "moment/locale/pt";
import moment from "moment";

import i18n from '../../i18n';

import { useTranslation } from 'react-i18next'

import Popup from "../Popup";
import validator from 'validator';
	const changeLanguage = (event) => {
		

		
	  console.log(event.target.value);
	  i18n.changeLanguage(event.target.value);

	  
	}

function Translate({value}) {
	const { t} = useTranslation();

	
	
	return  t(value) 
  }
class ExternalFatEle extends React.Component {
  constructor() {
    super();
    this.state = {
      data: -1,
      loading: true,
      aprovado: -2, 
      popupShow: false,
      popupTitle: "" , 
      popupLines: [""],
      mail_contato : "",
      disable : false
    };
    this.approveFatEle = this.approveFatEle.bind(this);
    this.refuseFatEle = this.refuseFatEle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.changePopupStatus = this.changePopupStatus.bind(this);
  }

  
  handleChange(event) {
    const inputName = event.target.name;
    
    console.log([inputName]);
    console.log( event.target.value);
    this.setState({
		
			[inputName]: event.target.value})

  }

  changePopupStatus() {
    console.log("change status");
      this.setState({
        popupShow: !this.state.popupShow,
    
      });
    }

  async approveFatEle() {


  
    if (!validator.isEmail(this.state.mail_contato)) {
			this.setState({
				popupShow: true,
        popupTitle: "Error" , 
        
				popupLines: [<Translate value ="emailinvalidofaturaeletronica" ></Translate>],
			
			  });

			return 
		  
		
    }
    
    this.setState({
      popupShow: true,
      popupTitle: <Translate value ="informacao" ></Translate>, 
      popupLines: [<Translate value ="aguardar" ></Translate>],
      disable:true
    
      });
    this.setState({ loading: true });
    await Axios.post(
      `https://${process.env.REACT_APP_API_IP}/api/clientapprovebillingdecision/approve`,
      { id: this.props.match.params.tokenId  , emailFaturaEletronica : this.state.mail_contato}
    )
      .then(response => {
        if (response.status === 200)
          this.setState({ aprovado: 1, loading: false ,  disable:false });
      })
      .catch(error => {
        console.log(error.response);
        this.setState({ aprovado: -1, loading: false , disable: false,
          popupShow : true ,
          popupTitle: "Error" , 
          popupLines: [<Translate value ="errointegracaocomservicosap" ></Translate>]  });
      });
  }

  async refuseFatEle() {
    console.log("refusing");
    this.setState({ loading: true , disable: true});
    await Axios.post(
      `https://${process.env.REACT_APP_API_IP}/api/clientapprovebillingdecision/decline`,
      { id: this.props.match.params.tokenId }
    )
      .then(response => {
        if (response.status === 200)
          this.setState({ aprovado: 0, loading: false , disable:false});
      })
      .catch(error => {
        console.log(error.response);
        this.setState({ disable:false
        
        ,    popupShow : true , 
      
      	popupTitle: "Error" , 
				popupLines: [<Translate value ="errointegracaocomservicosap" ></Translate>] 
      }); })
    
  }

  async fetchData(token) {
    await Axios.get(
      `https://${process.env.REACT_APP_API_IP}/api/clients/${this.props.match.params.tokenId}`
    )
      .then(response => {
        console.log(response);
        if (response.status === 200) {
          if (response.data.nome_2 !== null) {
            response.data.nome += " " + response.data.nome_2;
          }
          if (response.data.morada_2 !== null) {
            response.data.morada += " " + response.data.morada_2;
          }
          response.data.cd_post += ", " + response.data.localidade;
          this.setState({ loading: false, client: response.data ,
          mail_contato : response.data.mail_contato});
          if (response.data.fatEleAceitou) {
            this.setState({ data: 0, FatEleStatus: "Aceite" });
          } else if (response.data.fatEleAceitou === false) {
            this.setState({ data: 0, FatEleStatus: "Recusada" });
          } else {
            this.setState({ data: 1 });
          }
        } else {
          console.log("Resposta válida:");
          console.log(response);
        }
      })
      .catch(error => {
        console.log("Erro:");
        console.log(error.response);
        this.setState({ data: -1, loading: false });
      });
  }

  componentDidMount() {
    this.fetchData(this.props.match.params.tokenId);
    moment.locale("pt");
  }

  render() {
    const { data, loading, aprovado } = this.state;

    if (aprovado === 1) {
      return (
        <>
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 50 }} className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
            <div onChange={changeLanguage} >
      								<input type="radio" value="pt" name="language"  onChange ={this.handleChangeRadio}  />    Português 
    							    <input type="radio" value="en" name="language"  onChange ={this.handleChangeRadio} /> English
   						   </div>
                  <br></br><br></br>
              <div className="main-card mb-3 card">
                <div className="card-body">
                  <h4><Translate value ="faturaceitesucesso" ></Translate></h4>
                  <br />
                  <h5><Translate value ="obrigado" ></Translate></h5>
                </div>
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>{" "}
          <div className="fixed-bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
        </>
      );
    }
    if (aprovado === 0) {
      return (
        <>
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 50 }} className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
            <div onChange={changeLanguage} >
      								<input type="radio" value="pt" name="language"  onChange ={this.handleChangeRadio}  />    Português 
    							    <input type="radio" value="en" name="language"  onChange ={this.handleChangeRadio} /> English
   						   </div>
                  <br></br><br></br>
              <div className="main-card mb-3 card">
                <div className="card-body">
                  <h4><Translate value ="faturarecusadasucesso" ></Translate></h4>
                  <br />
                  <h6><Translate value ="obrigado" ></Translate></h6>
                </div>
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>{" "}
          <div className="fixed-bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
        </>
      );
    }
   
    if (data === 1) {
      return (
        <React.Fragment>
        <Popup
     updateStatus={this.changePopupStatus}
     popupShow={this.state.popupShow}
     popupTitle={this.state.popupTitle}
 popupLines={this.state.popupLines}

   ></Popup>
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 0 }} className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
            <div onChange={changeLanguage} >
      								<input type="radio" value="pt" name="language"  onChange ={this.handleChangeRadio}  />    Português 
    							    <input type="radio" value="en" name="language"  onChange ={this.handleChangeRadio} /> English
   						   </div>
                  <br></br><br></br>
              <div className="main-card mb-3 card text-center">
          
              
                <div className="card-title">
                <br></br>
                
                    

                    <Translate value ="adirafaturaeltronica" ></Translate>
                    
                   
                 
              </div>
              
                <div className="card-body">

                <div className="row">
                    <div className="col-sm-4 col-form-label"><Translate value ="Nif" ></Translate>:</div>
                    <div className="col-sm-8 col-form-label">
                      {this.state.client.nif}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-form-label"><Translate value ="Nome" ></Translate>:</div>
                    <div className="col-sm-8 col-form-label">
                      {this.state.client.nome}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-form-label"><Translate value ="Morada" ></Translate>:</div>
                    <div className="col-sm-8 col-form-label">
                      {this.state.client.morada}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-form-label">
                    <Translate value ="CodigoPostal" ></Translate>:
                    </div>
                    <div className="col-sm-8 col-form-label">
                      {this.state.client.cd_post}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-form-label">
                   <b> <Translate value ="EmailFaturaEletronica" ></Translate>:</b>
                    </div>
                    <div className="col-sm-8 col-form-label">
                 
                    
                    </div>
                  </div>


                  <div className="row">
                  
                    <div className="col-sm-12 col-form-label ">
                    <input
                    type="text"
                  
										className="form-control"
										value={this.state.mail_contato}
										onChange={this.handleChange}
										name="mail_contato"
										maxLength="250"
									/>
                    
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <button
                    onClick={this.approveFatEle}
                    disabled={this.state.disable}
                    className="mb-2 mr-2 btn btn-primary"
                  >
                     <Translate value ="aceitarfatura" ></Translate>
                  </button>
                  <button
                    disabled={this.state.disable}
                    onClick={this.refuseFatEle}
                    className="mb-2 mr-2 btn btn-danger"
                  >
                    <Translate value ="recusarfatura" ></Translate>
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>{" "}
          <div className="bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
          </React.Fragment>
      );
    }
  
    if (data === 0) {
      return (
        <>
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 50 }} className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
            <div onChange={changeLanguage} >
      								<input type="radio" value="pt" name="language"  onChange ={this.handleChangeRadio}  />    Português 
    							    <input type="radio" value="en" name="language"  onChange ={this.handleChangeRadio} /> English
   						   </div>
                  <br></br><br></br>
              <div className="main-card mb-3 card">
                <div className="card-header"><Translate value ="Nif" ></Translate>: {this.state.client.nif}</div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4 col-form-label"><Translate value ="Nome" ></Translate>:</div>
                    <div className="col-sm-8 col-form-label">
                      {this.state.client.nome}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-form-label"><Translate value ="Morada" ></Translate>:</div>
                    <div className="col-sm-8 col-form-label">
                      {this.state.client.morada}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-form-label">
                    <Translate value ="CodigoPostal" ></Translate>:
                    </div>
                    <div className="col-sm-8 col-form-label">
                      {this.state.client.cd_post}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-form-label">
                    <Translate value ="EmailFaturaEletronica" ></Translate>:
                    </div>
                    <div className="col-sm-8 col-form-label">
                      {this.state.client.mail_contato}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-form-label">
                    <Translate value ="estado" ></Translate>:
                    </div>
                    <div className="col-sm-8 col-form-label">
                    <Translate value = {this.state.FatEleStatus} ></Translate>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-form-label">
                     <Translate value = "data" ></Translate>
                    </div>
                    <div className="col-sm-8 col-form-label">
                      <Moment format="DD-MM-YYYY HH:mm[h] [(dd-mm-yyyy)] ">
                        {this.state.client.fatEleAceiteEm}
                      </Moment>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>
          <div className="fixed-bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
        </>
      );
    } else if( !loading) {
      return (
       
        <>
        
          <div className="row">
            <img
              style={{
                marginTop: 70,
                width: "100px",
                height: "auto"
              }}
              className="mx-auto"
              src={logo}
              alt="isq logo"
            />
          </div>
          <div style={{ marginTop: 50 }} className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
            <div onChange={changeLanguage} >
      								<input type="radio" value="pt" name="language"  onChange ={this.handleChangeRadio}  />    Português 
    							    <input type="radio" value="en" name="language"  onChange ={this.handleChangeRadio} /> English
   						   </div>
                  <br></br><br></br>
              <div className="main-card mb-3 card">
                <div className="card-body">
                <Translate value = "erroobtercomolinkdeacessofornecido" ></Translate>
                 
                  <br />
                  {this.props.match.params.tokenId}
                </div>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>{" "}
          <div className="fixed-bottom" style={{ textAlign: "center" }}>
            Faturação Eletrónica – Aceitação Tácita Artº 36º nº 10 do Código do
            IVA e DL 28 / 2019 de 15 / 2, artº 12 nº 1
          </div>
        </>
      );

      }else {
        
         return ("");
      }
    }
  
}

export default ExternalFatEle;
